{
  "setupWorkplaceStep": {
    "title": "Configurons votre lieu de travail !",
    "description": "Vous devez compléter les trois étapes suivantes pour créer un lieu de travail",
    "pill": {
      "setupNow": "Configurer"
    },
    "options": {
      "sso": {
        "title": "Connectez votre SSO",
        "description": "Configurez l'authentification unique pour gérer l'accès à votre organisation.",
        "tooltipTitle": "Texte d'aide",
        "buttonLabel": "Gérer"
      },
      "orgChat": {
        "title": "Connectez votre organigramme",
        "description": "Importez la structure de votre organisation pour activer les flux de travail automatisés.",
        "tooltipTitle": "Texte d'aide",
        "buttonLabel": "Configurer"
      },
      "communicationTool": {
        "title": "Connectez l'outil de communication",
        "description": "Collectez les retours des employés via les plateformes de communication de votre équipe.",
        "tooltipTitle": "Texte d'aide",
        "buttonLabel": "Configurer"
      },
      "billing": {
        "title": "Configurer la facturation",
        "description": "Ajoutez vos informations de facturation et choisissez un plan adapté à vos besoins.",
        "tooltipTitle": "Texte d'aide",
        "buttonLabel": "Configurer"
      }
    }
  },
  "connectSsoStep": {
    "title": "Connectez votre fournisseur SSO",
    "description": "Configurez l'authentification unique pour gérer l'accès à votre organisation",
    "backButton": "Retour à la configuration",
    "options": {
      "domain": {
        "title": "Vérifier le domaine de l’organisation",
        "buttonLabel": "Vérifier"
      },
      "provider": {
        "title": "Configurer le fournisseur d'identité",
        "buttonLabel": "Configurer"
      }
    }
  },
  "connectOrgChatStep": {
    "title": "Connectez votre organigramme",
    "description": "Importez la structure de votre organisation pour activer des workflows automatisés",
    "backButton": "Retour à la configuration",
    "options": {
      "workday": { "title": "Workday", "buttonLabel": "Connecter" },
      "bamboo": { "title": "BambooHR", "buttonLabel": "Connecter" }
    }
  },
  "connectCommunicationToolStep": {
    "title": "Connectez votre outil de communication",
    "description": "Toutes les questions quotidiennes seront collectées via l'outil de communication que vous utilisez",
    "backButton": "Retour à la configuration",
    "options": {
      "slack": { "title": "Slack", "buttonLabel": "Connecter" },
      "teams": { "title": "Microsoft Teams", "buttonLabel": "Connecter" }
    }
  },
  "billingStep": {},
  "alertDialog": {
    "trigger": "Configurer plus tard",
    "title": "Voulez-vous ignorer la configuration ?",
    "description": "Ignorer la configuration signifie que vous devrez configurer votre espace de travail plus tard. Certaines fonctionnalités pourraient ne pas être disponibles avant la fin de la configuration.",
    "actionButton": "Continuer la configuration",
    "cancelButton": "Ignorer la configuration"
  }
}
